import Cta from "components/home/cta";
import Hero from "components/works/hero";
import WorksBanner from "components/works/worksBanner";
import WorksFaq from "components/works/worksFaq";
import WorksGrid from "components/works/worksGrid";
import WorksOne from "components/works/worksOne";
import Head from "next/head";
import styled from "styled-components";

const StyledWrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const Features = () => {
  return (
    <>
      <Head>
        <title>Redact - How it works</title>
        <meta charSet="utf-8" />
        <link rel="icon" href="/images/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#000000" />
        <meta name="robots" content="noarchive" />
        <meta
          name="description"
          content="Redact - Stay up to date with the latest Redact features. Download latest Redact version and join our Discord for more updates."
        />
        <meta name="keywords" content="redact mass delete privacy free features" />

        <meta property="og:title" content="Redact - How it works" />
        <meta
          property="og:description"
          content="Stay up to date with the latest Redact features. Download latest Redact version and join our Discord for more updates."
        />

        <meta property="og:image" content="https://redact.dev/images/head-thumbnail.jpg" />
        <meta property="twitter:image" content="https://redact.dev/images/head-thumbnail.jpg" />
        <meta property="og:url" content="https://www.redact.dev/business" />
        <link rel="apple-touch-icon" href="images/logo192.png" />
      </Head>
      <StyledWrapper>
        <Hero />
        <WorksOne />
        <WorksBanner />
        <WorksGrid />
        <WorksFaq />
        <Cta />
      </StyledWrapper>
    </>
  );
};

export default Features;
